import React from 'react';
import { useForm } from 'react-hook-form';
import FormInput from '../../../components/FormInput/FormInput';
import { FORM_INPUT_COMPONENT_TYPES, FORM_INPUT_TYPES, isLocaleDDMMYYYY } from '../../../components/FormInput/types';
import { vars } from '../../../reactive';
import { increaseFormPage } from '../../../reactive/actions';
import { replaceVariables } from '../../../utils';

const FormPetBirthday = () => {
  const type = FORM_INPUT_TYPES.DATE;
  const { title } = FORM_INPUT_COMPONENT_TYPES[type];
  const formOptions = useForm();

  const newPet = vars.newPet();

  const onSubmit = (data: Record<string, Array<string>>) => {
    const birthday = data.DATE.reverse();
    const yyyy = birthday[0];
    const mm = isLocaleDDMMYYYY ? birthday[1] : birthday[2];
    const dd = isLocaleDDMMYYYY ? birthday[2] : birthday[1];

    const birthdayString = new Date(Date.UTC(parseInt(yyyy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10))).toISOString();

    vars.newPet({ ...newPet, birthday: birthdayString });
    increaseFormPage();
  };

  return <FormInput type={type} formOptions={formOptions} onSubmit={onSubmit} title={replaceVariables(title, { petName: newPet.name })} includeTip={true} />;
};

export default FormPetBirthday;
